module.exports = __webpack_public_path__ + "img/dark-mud-decal-14.e42ee35a.png";